


















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditClosure from "./edit-closure.vue";
import Ajax from "../../lib/ajax";
class PageClosureRequest extends PageRequest {
    courtName: string;
}

@Component({
    components: { EditClosure },
})
export default class Closure extends AbpBase {
    // 编辑按钮事件处理
    edit() {
        this.editModalShow = true;
    }
    menuClick(name, row) {
        switch (name) {
            case "edit":
                this.$store.commit("closure/edit", row);
                this.edit();
                break;
            case "delete":
                this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteWarningMessage"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                        await this.$store.dispatch({
                            type: "closure/delete",
                            data: row,
                        });
                        await this.getpage();
                    },
                });
                break;
            default:
                break;
        }
    }
    //filters
    pagerequest: PageClosureRequest = new PageClosureRequest();

    createModalShow: boolean = false;
    editModalShow: boolean = false;

    closureCourtId: number = 0;

    get list() {
        return this.$store.state.closure.list;
    }
    get loading() {
        return this.$store.state.closure.loading;
    }

    pageChange(page: number) {
        this.$store.commit("closure/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("closure/setPageSize", pagesize);
        this.getpage();
    }
    search() {
        this.$store.commit("closure/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        await this.$store.dispatch({
            type: "closure/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.closure.pageSize;
    }
    get totalCount() {
        return this.$store.state.closure.totalCount;
    }
    get currentPage() {
        return this.$store.state.closure.currentPage;
    }
    columns = [
        {
            title: this.L("CourtName"),
            key: "courtName",
        },
        {
            title: this.L("StartDate"),
            key: "startDate",
            width: 120,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    new Date(params.row.startDate).toLocaleDateString()
                );
            },
        },
        {
            title: this.L("EndDate"),
            key: "endDate",
            width: 120,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    new Date(params.row.endDate).toLocaleDateString()
                );
            },
        },
        {
            title: this.L("StartTime"),
            key: "startTime",
            width: 120,
            render: (h: any, params: any) => {
                return h("span", Util.int2time(params.row.startTime));
            },
        },
        {
            title: this.L("EndTime"),
            key: "endTime",
            width: 120,
            render: (h: any, params: any) => {
                return h("span", Util.int2time(params.row.endTime));
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 100,
            align: "center",
            slot: "action"
        },
    ];
    async created() {
        this.getpage();
    }
}
